import React from "react";
import { Box } from "@sparrowengg/twigs-react";
import Fallback from "features/fallback/components";
import Navbar from "commons/components/navbar";

const FallbackPage = () => {
  return (
    <Box css={{ height: "100vh", width: "100vw" }}>
      <Navbar />
      <Fallback />
    </Box>
  );
};

export default FallbackPage;
